import React from "react";
import visa from "../../assets/images/icons/visa-updatepyment-49X16.png";
import mastercard from "../../assets/images/icons/mastercard-updatepyment-34X22.png";
import discover from "../../assets/images/icons/dis-updatepyment-80X13.png";
import axios from "axios";
import Swal from "sweetalert2";

class UpdatePayment extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      updatePaymentIframeAPI: '',
      updatePaymentIframeSrc: '',
      updatePaymentSessionKey: '',
      paymentKeys: '',
      title: '',
      content: ''
    }
  }

  componentDidMount = () => {
    document.body.scrollTo(0, 0);
    this.updatePaymentIframeAPI();
    this.addMessageListener();
    this.props.headerHideFun();
    this.props.footerHideFun();
  };

  updatePaymentpopup = () => {
    let title = this.state.title;
    let message = this.state.content;
    Swal.fire({
      customClass: {
        container: "updatpayment-popup",
      },
      html: '<aside class="popup"><h2>'+title+'</h2><p class="invaliduser">' + message + "</p></aside>",
      showCloseButton: false,
      showConfirmButton: true,
      allowOutsideClick: false,
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        window.updatePaymentBack();
      }
    });
  };

  
  updatePaymentIframeAPI = () => {
    // let getPath = this.props.location;
    let getPath = window.location;
    let splitSubId = getPath.pathname.split('&');
    let subId = splitSubId[0].split('=')[1];
    let splitToken = getPath.pathname.split('&');
    let tokenValue = splitToken[1].split('token=')[1]
    
    let headers = {
      appplatform: 'WEBSITE',
      appversion: '1.0.0',
      Authorization: `Bearer ${tokenValue}`,
    };
    let body = {
      subscriptionid: subId,
      type: "verify" 
    };
    axios.post(process.env.REACT_APP_BASEURL + "/subscription/v1/checkout/payment/init", body, {headers})
      .then((response) => {
        // console.log(response.data);
        
        if (response.data.code == "000") {
          // console.log(response.data);
          var splitSrc = response.data.iframe.split('src="');
          // var getSrc = splitSrc[1].split('">');
          var getSrc = splitSrc[1].split('"');
          // console.log(getSrc[0])
          var sessionKey = getSrc[0].split("sessionKey=");
          this.setState({
            updatePaymentIframeAPI: response.data,
            updatePaymentIframeSrc: getSrc[0],
            updatePaymentSessionKey: sessionKey[1]
          });
        }
        if (response.data.code == "001") {
          console.log(response.data.message);
        }
      })
  };


  submitUpdatePaymentForm = () => {
    // let getPath = this.props.location;
    let getPath = window.location;
    let splitSubId = getPath.pathname.split('&');
    let subId = splitSubId[0].split('=')[1];
    let splitToken = getPath.pathname.split('&');
    let tokenValue = splitToken[1].split('token=')[1]

    let headers = {
      appplatform: 'WEBSITE',
      appversion: '1.0.0',
      Authorization: `Bearer ${tokenValue}`,
    };
    let body = {
      subscriptionid: subId,
      paymentKey: this.state.paymentKeys,
      nameOnCard: this.props.state.updatePaymentNameOnCard,
      token: this.state.updatePaymentSessionKey,
    };
    axios.post(process.env.REACT_APP_BASEURL + "/subscription/v1/checkout/payment/verify", body, {headers})
      .then((response) => {
        console.log(response.data);
        if (response.data.code == 200) {
          this.setState({
            title: 'Update Payment Info Successful!',
            content: 'Your card detail is successfully updated and will be used for your future subscription renewal payments.'
          }, () => {
            this.updatePaymentpopup()
          })
        }
        if (response.data.code == 500) {
          this.setState({
            title: 'Update Payment Info Failed',
            content: 'There was error updating your payment card information. Please try again.'
          }, () => {
            this.updatePaymentpopup()
          })
        }
      }).catch((error) => {
        this.setState({
          title: 'Update Payment Info Failed',
          content: 'There was error updating your payment card information. Please try again.'
        }, () => {
          this.updatePaymentpopup()
        })
      })
  };


  addMessageListener = () => {
    window.addEventListener("message", this.handleMessage);
  };

  handleMessage = (e) => {
    var message = e.data,
    data = message.data;
    // console.log(message);

    switch (message.type) {
      case 1:
        // handleErrors(data);
        break;
      case 2:
        // setFrameHeight(data);
        break;
      case 3:
        // submitPayment(data);
        // console.log(data);
        // console.log(data.paymentKeys[0]);
        if(data.paymentKeys[0]){
          this.setState({
            paymentKeys: data.paymentKeys[0],
          }, () => {
            this.submitUpdatePaymentForm();
          });
        }
        break;
      case 4:
        // handleValidityChange(data);
        break;
      case 15:
        this.props.handleLegalClick(data);
        break;
    }
  };



  render() {
    return (
      <section className="mmf-payment-page update-payment">
        <section className="row">
          <section className="payment-inner col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <section className="payment-body">
              <aside className="month-head text-center">
                <p>Used for monthly renewal of your CMX Passport</p>
              </aside>
              <section className="cd-card-blk">
                <h3>Credit /Debit Card</h3>
                <section className="accept-card">
                  <p className="d-inline-block align-middle">We accept</p>
                  <figure className="d-inline-block align-middle ps-2">
                    <p><img src={visa} alt="CMX Passport" className="img-fluid" /></p>
                    <p><img src={mastercard} alt="CMX Passport" className="img-fluid" /></p>
                    <p><img src={discover} alt="CMX Passport" className="img-fluid" /></p>
                  </figure>
                </section>
                {/* <aside className='visa-error-blk'>
                  <p>Currently, our program is not accepting VISA payments. This will be corrected soon.</p>
                  <p>Accepting only U.S. zip codes</p>
                </aside> */}

                <section className="name-on-card">
                  <aside className="inner-form-group position-relative">
                    <label>Name on card</label>
                    <input onChange={(e) => this.props.updatePaymentNameOnCard(e)} name="updatePaymentNameOnCard" value={this.props.state.updatePaymentNameOnCard} type="text" placeholder="Name on card" autoComplete="off" />
                  </aside>
                </section>

                <section className="cd-form-blk">
                  <iframe frameBorder="0" src={this.state.updatePaymentIframeSrc}></iframe>
                </section>
              </section>
            </section>
          </section>
        </section>
      </section>
    );
  }
}

export default UpdatePayment;
